module.exports = "<template> <sio-context-model-fields config.bind=field value.bind=field.value></sio-context-model-fields> </template> ";